import React from 'react';


export class LabeledInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.generateState()
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props !== prevProps) {
            this.setState(this.generateState());
        }
    }

    generateState = () => {
        return {
            color: 'main',
            label: '',
            value: '',
            placeholder: '',
            type: 'text',
            height: 'auto',
            dataAttribute: null,
            onChange: (event) => {},
            onKeyDown: (event) => {},
            onBlur: (event) => {},
            ...this.props
        };
    }

    render() {
        return (
            <label className="imd-form-label">
                <span className="imd-text-light-gray">{this.state.label}</span>
                <input
                    className={'imd-form-control imd-border-bottom-color-' + this.state.color + ' imd-text-' + this.state.color}
                    type={this.state.type}
                    style={{height: this.state.height}}
                    value={this.state.value}
                    placeholder={this.state.placeholder}
                    data-attribute={this.state.dataAttribute}
                    onChange={(event) => this.state.onChange(event)}
                    onKeyDown={(event) => this.state.onKeyDown(event)}
                    onBlur={(event) => this.state.onBlur(event)}
                />
            </label>
        );
    }
}
